import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-344b3a6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "本站为\"课·视频[ke.video]\"和\"题·视频[ti.video]\"联合站."),
  /*#__PURE__*/_createElementVNode("div", null, "系统正在建设中，部分功能处于调试阶段，敬请期待！")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, "*", -1))
const _hoisted_4 = { class: "text-container" }
const _hoisted_5 = { class: "card-footer" }
const _hoisted_6 = { class: "icon-container" }
const _hoisted_7 = { class: "text-container" }

import { ref } from 'vue'
import { Star } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const introduction = ref([
  '课·视频致力于为广大一线教师提供多平台丰富的视频微课、公开课、精品课等资源。',
  '课程信息和内容主要来源于国家和地方相关课程资源，如：国家中小学智慧教育云平台。',
  '资源类型包含多种常用类型，如：视频、课件、教案、学习任务单、课后练习等。',
  '资源处理和加工主要包含：根据视频文件转写文字，生成逐字稿、字幕文件、字幕视频等资源。',
  '资源格式包含常见的 mp4 视频文件，ppt 课件，docx 教案，还有 pdf 格式的资源。',
  '题·视频网站主要收集整理各地中高考真题和模拟试卷，进行深加工，比如 pdf 转换为 word 或者 markdown 等。'
])

const footerText = ref([
  '本站提供的资源和方法为互联网公开资源和站长亲自动手制作处理。',
  '如涉及相关版权问题，请与站长联系删除相关资源文件和引用链接。',
  '本站为广大一线教师提供专业服务，商家勿扰，禁止将本站处理成果进行倒卖。'
])

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerText.value, (item, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                class: "footer-item"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Star))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(introduction.value, (text, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "content-item"
            }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, _toDisplayString(text), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})